import { format, intlFormat } from 'date-fns';
import type { ErrorDetails } from '#api/errors.ts';
import { InlineButton } from '#components/atoms/buttons/inline-button/InlineButton.tsx';
import { calculateStreamState } from '../../calculateStreamState.ts';

const TIME_FORMAT = 'h:mm aa';

type Props = {
  onRestart: () => void;
  sessionStart: Date | null;
  sessionEnd: Date | null;
  errorMsg?: string;
  errors: ErrorDetails[];
};

export function DebugStatus({ onRestart, sessionStart, sessionEnd, errors }: Props) {
  const { state, at } = calculateStreamState({ sessionStart, sessionEnd, errors });

  if (state === 'init') {
    return (
      <div className="p-md">
        Send a command from the menu or
        <InlineButton className="ml-0" onClick={onRestart}>
          Start streaming
        </InlineButton>
      </div>
    );
  }

  if (state === 'started') {
    return (
      <div className="p-md">
        Debug session started on{' '}
        {intlFormat(new Date(at), {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
        })}{' '}
        at {format(at, TIME_FORMAT)}
      </div>
    );
  }

  if (state === 'disconnected') {
    return (
      <div className="p-md">
        Lost connection on{' '}
        {intlFormat(new Date(at), {
          month: 'numeric',
          day: 'numeric',
          year: 'numeric',
        })}{' '}
        at {format(at, TIME_FORMAT)}{' '}
        <InlineButton className="ml-0" onClick={onRestart}>
          Retry
        </InlineButton>
      </div>
    );
  }

  // Session finished
  return (
    <div className="p-md">
      Debug session ended on{' '}
      {intlFormat(new Date(at), {
        month: 'numeric',
        day: 'numeric',
        year: 'numeric',
      })}{' '}
      at {format(at, TIME_FORMAT)}{' '}
      <InlineButton className="ml-0" onClick={onRestart}>
        Restart
      </InlineButton>
    </div>
  );
}
